import React, {useState} from "react";
import ConfigScreen from "../../../../common/components/game-screens/ConfigScreen";
import { RedoOutlined, EyeOutlined, LinkOutlined, LoadingOutlined } from "@ant-design/icons";
import { QRCode } from 'antd';
import uuid from "react-uuid";
import {setItem, useItemValue} from "../../../../common/firebase/db";
import {useDebouncedEffect} from "../../../../common/hooks";
import {LINES_GAME as GAME} from "../../../../common/utils/games";
import {useTranslation} from "react-i18next";
import {getWithDefault} from "../../../../common/utils/storage";
import {LocalStorage} from "../../../../common/types";

interface Props {
    backToDetails: () => void;
    nextToPlay: () => void;
    lines: string[];
    setLines(lines: string[]): void
}

const LinesGameConfig = ({backToDetails, nextToPlay, lines, setLines}: Props) => {
    const [resetting, setResetting] = useState<boolean>(false);

    const gameId = getWithDefault(LocalStorage.GAME_ID_STORAGE, uuid);
    const gameUrl = document.location.origin + `/games/${GAME.name}`;
    const gameLineSubmitUrl = `${gameUrl}/${gameId}/submit`;
    const gameLinesAdminUrl = `${gameUrl}/${gameId}/admin`;

    const linesFromDb = useItemValue(`/games/${gameId}`);
    useDebouncedEffect(() => {
        setLines(Object.values(linesFromDb));
    }, [linesFromDb], 1000);

    const {t} = useTranslation();
    const confirmMessage = t('games.lines.settings.resetConfirm');
    const resetLines = () => {
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        setResetting(true);
        setItem(`/games/${gameId}`, {})
            .then(() => {setResetting(false);})
            .catch(() => {setResetting(false);});
    };

    return <ConfigScreen
        configTitlePath="games.lines.settings.title"
        backToDetails={backToDetails}
        nextToPlay={nextToPlay}
        nextActionDisabled={lines.length === 0}
    >
        <QRCode size={256} value={gameLineSubmitUrl} />
        <div className="w-[256px] flex justify-between mt-[10px] mb-[38px]">
            <span>{lines.length}</span>
            <div className="flex flex-row gap-[20px]">
                <a href={gameLineSubmitUrl} target="_blank" rel="noreferrer"><LinkOutlined/></a>
                <a href={gameLinesAdminUrl} target="_blank" rel="noreferrer"><EyeOutlined/></a>
                <span>
                {resetting
                    ? <LoadingOutlined />
                    : <RedoOutlined onClick={resetLines} className="cursor-pointer" disabled={lines.length === 0}/>
                }
                </span>
            </div>
        </div>
    </ConfigScreen>;
};

export default LinesGameConfig;
